module.exports = "/_next/static/images/banner-64f5a9a6e2be7cf6a5adc8ad970f1679.jpg.webp";